import { Divider as AntdDivider } from "@empglabs/backoffice-ui-kit"
const Divider = props => {
  return <AntdDivider {...props} />
}

export default Divider
